
export class TVChannel {
    id: number;
    name: string;
    logo: string;
}

export default class Broadcast {
    type: number;
    betRadarId: number;
    name: string;
    channels: TVChannel[];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/broadcast/Broadcast.ts